import { HeartHandshake, Landmark, Sparkles } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";

const icons = [HeartHandshake, Landmark, Sparkles];

function CountryLifestyleSection({ country }) {
  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Student Life"
          title={country.lifestyle.title}
          description={country.lifestyle.description}
        />

        <div className="mt-10 grid gap-5 md:grid-cols-2 xl:grid-cols-4">
          {country.lifestyle.highlights.map((highlight, index) => {
            const Icon = icons[index % icons.length];

            return (
              <div
                key={highlight}
                className="signature-card signature-card-interactive rounded-2xl p-5 text-center"
              >
                <span className="mx-auto inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sky-glow text-royal-blue">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <p className="mt-4 text-sm font-medium text-slate-text/85">{highlight}</p>
              </div>
            );
          })}
        </div>
      </div>
    </MotionSection>
  );
}

export default CountryLifestyleSection;
